<template>
  <v-footer  padless class="mt-5">
    <v-card class="flex" flat tile>

      <v-card-text class="py-2 text-right">
        PandaCode🐼{{ new Date().getFullYear() }} 
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
export default {
  name: "PieComponent",
};
</script>


// WEBPACK FOOTER //
// src/components/Dialogos/PieComponent.vue